import { getHeaders } from '../xhrRequest';
import { createAction } from 'redux-api-middleware';

export const FETCH_COUNTRY_ISO_CODE = 'FETCH_COUNTRY_ISO_CODE';
export const FETCH_COUNTRY_ISO_CODE_SUCCESS = 'FETCH_COUNTRY_ISO_CODE_SUCCESS';
export const FETCH_COUNTRY_ISO_CODE_FAILURE = 'FETCH_COUNTRY_ISO_CODE_FAILURE';

export const fetchCountryIsoCode = () => createAction({
    types: [
        FETCH_COUNTRY_ISO_CODE,
        FETCH_COUNTRY_ISO_CODE_SUCCESS,
        FETCH_COUNTRY_ISO_CODE_FAILURE,
    ],
    endpoint: `/api/country/iso-code`,
    headers: getHeaders(),
    method: 'GET',
    credentials: 'include'
});